import PropTypes from 'prop-types';

// These functions are used in MediocrePlugins.getTableItemProps and tableEditablePropsFromEditor,
// which are used by DataTableEditable. DataTableEditable is used in AssayGroupResultsTable,
// which uses SpreadsheetEvalMixin, which provides these methods. When SpreadsheetEvalMixin
// is fully replaced with withSpreadsheetEvaluation, this mixin can be removed.

const WithSpreadsheetEvaluationUserMixin = {
  propTypes: {
    extraUsedTableNames: PropTypes.func,
    getAllStoreDependenciesFromSpreadsheetRoot: PropTypes.func,
    getContent: PropTypes.func.isRequired,
    getSpreadsheetTableName: PropTypes.func.isRequired,
    getItems: PropTypes.func.isRequired,
    getRoot: PropTypes.func.isRequired,
    getSpreadsheetEvalCacheKey: PropTypes.func,
    getType: PropTypes.func.isRequired,
    itemsAccessor: PropTypes.func.isRequired,
    makeFullTableMap: PropTypes.func.isRequired,
    selectorsFromProps: PropTypes.func.isRequired,
    setContent: PropTypes.func.isRequired,
    spreadsheetRoot: PropTypes.func.isRequired,
    spreadsheetTypes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    updateRoot: PropTypes.func.isRequired,
    evaluateTables: PropTypes.func.isRequired,
    setMultiEditingForTable: PropTypes.func.isRequired,
    tryInsert: PropTypes.func.isRequired,
    canInsert: PropTypes.func.isRequired,
    disallowMultiExpand: PropTypes.func.isRequired,
    deleteTableRows: PropTypes.func.isRequired,
    deleteTableColumns: PropTypes.func.isRequired,
    insertTableRowsAbove: PropTypes.func.isRequired,
    insertTableRowsBelow: PropTypes.func.isRequired,
    reorderTableRowsOrColumns: PropTypes.func.isRequired,
    insertTableColumnsLeft: PropTypes.func.isRequired,
    insertTableColumnsRight: PropTypes.func.isRequired,
    renameTable: PropTypes.func.isRequired,
    performTableOp: PropTypes.func.isRequired,
    mergeTableRegion: PropTypes.func.isRequired,
    unmergeTableRegion: PropTypes.func.isRequired,
    mergeIntoSingleInput: PropTypes.func.isRequired,
    unmergeSingleInput: PropTypes.func.isRequired,
    updateSelectors: PropTypes.func.isRequired,
    usedTableNames: PropTypes.func.isRequired,
    isTableNameUsed: PropTypes.func.isRequired,
  },

  getRoot(props) {
    return this.props.getRoot(props);
  },

  getCid(item) {
    return this.props.getCid(item);
  },

  getContent(item) {
    return this.props.getContent(item);
  },

  getSpreadsheetTableName(item) {
    return this.props.getSpreadsheetTableName(item);
  },

  setMultiEditingForTable(tableName, args) {
    this.props.setMultiEditingForTable(tableName, args);
  },

  tryInsert(tableName, e) {
    return this.props.tryInsert(tableName, e);
  },

  canInsert(e) {
    return this.props.canInsert(e);
  },

  deleteTableRows(index, start, end) {
    this.props.deleteTableRows(index, start, end);
  },

  deleteTableColumns(index, start, end) {
    this.props.deleteTableColumns(index, start, end);
  },

  insertTableRowsAbove(index, start, end) {
    this.props.insertTableRowsAbove(index, start, end);
  },

  insertTableRowsBelow(index, start, end) {
    this.props.insertTableRowsBelow(index, start, end);
  },

  reorderTableRowsOrColumns(index, options) {
    this.props.reorderTableRowsOrColumns(index, options);
  },

  insertTableColumnsLeft(index, start, end, columnInfo) {
    this.props.insertTableColumnsLeft(index, start, end, columnInfo);
  },

  insertTableColumnsRight(index, start, end, columnInfo) {
    this.props.insertTableColumnsRight(index, start, end, columnInfo);
  },

  renameTable(index, newTableName) {
    this.props.renameTable(index, newTableName);
  },

  performTableOp({index, op, options}) {
    this.props.performTableOp({index, op, options});
  },

  mergeTableRegion(index, selectedBox) {
    this.props.mergeTableRegion(index, selectedBox);
  },

  unmergeTableRegion(index, selectedBox) {
    this.props.unmergeTableRegion(index, selectedBox);
  },

  mergeIntoSingleInput(tableIndex, startIndex, endIndex) {
    this.props.mergeIntoSingleInput(tableIndex, startIndex, endIndex);
  },

  unmergeSingleInput(tableIndex, startIndex, endIndex) {
    this.props.unmergeSingleInput(tableIndex, startIndex, endIndex);
  },

  isTableNameUsed(tableName) {
    return this.props.isTableNameUsed(tableName);
  },

  getDataForTableItemProps() {
    return {
      tableNamespace: this.props.tableNamespace,
      showExcessLabels: this.props.showExcessLabels,
      computedTables: this.props.computedTables,
      cellColors: this.props.cellColors,
      editingTable: this.props.editingTable,
      selectorCounts: this.props.selectorCounts,
      fullTableMap: this.props.fullTableMap,
    };
  },
};

export default WithSpreadsheetEvaluationUserMixin;
